export type SortableValue = string | number;

function compareSortable(a: SortableValue, b: SortableValue): number {
  return typeof a === "string" && typeof b === "string"
    ? a.localeCompare(b)
    : (a as number) - (b as number);
}

// Turns a map of sort key -> value accessor into comparators, so adding a
// column only means declaring how to read its value - the comparison itself
// (string vs number, and tie-breaking across a tuple) follows from the
// accessor's return type rather than a hand-written comparator per column.
export function createSortComparators<T, SortKey extends string>(
  accessors: Record<SortKey, (row: T) => SortableValue | SortableValue[]>
): Record<SortKey, (a: T, b: T) => number> {
  const comparators = {} as Record<SortKey, (a: T, b: T) => number>;

  for (const key of Object.keys(accessors) as SortKey[]) {
    const accessor = accessors[key];
    comparators[key] = (a, b) => {
      const valuesA = ([] as SortableValue[]).concat(accessor(a));
      const valuesB = ([] as SortableValue[]).concat(accessor(b));

      for (let i = 0; i < valuesA.length; i++) {
        const result = compareSortable(valuesA[i], valuesB[i]);
        if (result !== 0) return result;
      }
      return 0;
    };
  }

  return comparators;
}
